import { render, staticRenderFns } from "./EmployerDetailsStep.component.vue?vue&type=template&id=2c2f29f8&"
import script from "./EmployerDetailsStep.component.vue?vue&type=script&lang=ts&"
export * from "./EmployerDetailsStep.component.vue?vue&type=script&lang=ts&"
import style0 from "./EmployerDetailsStep.component.vue?vue&type=style&index=0&id=2c2f29f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports